var ChollosFilterer = function () {

    var self = this;

    this.initialize = function () {

        this.eventDelegation();

        if($('#numNights').find('.collapse-text').height() <= 40) {
            $('[data-target="#numNights"]').hide();
            $('#numNights').removeClass('collapse collapse-no-complete-40');
        }

        this.filterMealPlanByUrlParameter();
        this.filterHotelByUrlParameter();
        if (typeof showDates !== 'undefined') {
            this.hideNightSelector();
        }
    };

    this.eventDelegation = function () {
        let filterSelectors = $('[data-filter="chollos"]');
        let nightsSelector = $('[data-type="nights"]');
        let mealPlanSelector = $('[data-type="mealplan"]');
        let hotelsSelector = $('[data-type="hotels"]');

        if ((nightsSelector.length != 0 && nightsSelector.val() != '') ||
            (mealPlanSelector.length != 0 && mealPlanSelector.val() != '') ||
            (hotelsSelector.length != 0 && hotelsSelector.val() != '')) {
            self.doFilter();
        }

        filterSelectors.on('change', function () {
            self.doFilter();
        });
    };

    this.filterMealPlanByUrlParameter = function () {
        let searchParams = new URLSearchParams(window.location.search);
        let mealPlanId = searchParams.get('mealPlanId');
        if (mealPlanId && $('[data-type="mealplan"] option[value=' + mealPlanId + ']').length > 0) {
            $('[data-type="mealplan"]').val(mealPlanId).change();
        }
    }

    this.filterHotelByUrlParameter = function () {
        let searchParams = new URLSearchParams(window.location.search);
        let hotelId = searchParams.get('hotelId');
        if (hotelId && $('[data-type="hotels"] option[value=' + hotelId + ']').length > 0) {
            $('[data-type="hotels"]').val(hotelId).change();
        }
    }

    this.scrollToFiltersModule = function() {
        if (!myApp.deviceDetector.isXsScreen() && !myApp.deviceDetector.isSmScreen()) {
            return;
        }

        var scrollTargetId = '[data-filter="chollos"]';
        var scrollTargetPosition = $(scrollTargetId).offset().top;
        var scrollCurrentPosition = document.documentElement.scrollTop;

        if (scrollCurrentPosition > scrollTargetPosition) {
            return;
        }

        myApp.scrollManager.scrollToElement(scrollTargetId);
    }

    this.doFilter = function () {
        this.scrollToFiltersModule();
        this.applyShadowOnFiltrableItems();
        this.uncollapseOptions();
        self.applyFilters();
        setTimeout(function () {
            self.removeShadowOnFiltrableItems();
            self.expandFirstCholloDetails();
        }, 500);
    };

    this.hideNightSelector = function () {
        let nightsSelector = document.querySelector('[data-type="nights"]');
        let mealPlanSelector = document.querySelector('[data-type="mealplan"]');
        let hotelsSelector = document.querySelector('[data-type="hotels"]');
        let titleContainer = document.querySelector('[data-entity="filter-title"]');

        if (nightsSelector) {
            document.querySelector('[data-type="nights"]').closest('article').style.display = 'none';
        }
        if (!mealPlanSelector && !hotelsSelector && titleContainer) {
            titleContainer.style.display = 'none';
        }
    }

    this.applyShadowOnFiltrableItems = function() {
        $('#groupSubchollos').addClass('opacity-30');
    };

    this.removeShadowOnFiltrableItems = function() {
        $('#groupSubchollos').removeClass('opacity-30');
    };

    this.expandFirstCholloDetails = function() {
        let seeMoreDetailsElement = $($('[data-filtrable="true"]:visible')[0]).find('.see-more-details-text');
        if (seeMoreDetailsElement.is(':visible')) {
            seeMoreDetailsElement.click();
        }
    };

    this.applyFilters = function () {
        let selectedMealplan = $('[data-type="mealplan"]').val();
        let selectedNights = $('[data-type="nights"]').val();
        let selectedHotel =  $('[data-type="hotels"]').val();
        let selectedAirport =  $('[data-type="airport"]').val();
        let selectedJourney =  $('[data-type="journey"]').val();
        let selectedActivity =  $('[data-type="activity"]').val();

        var dataFiltrable = $('[data-filtrable="true"]');
        dataFiltrable.each(function () {
            self.filterChollos(selectedMealplan, selectedNights, selectedHotel, selectedAirport, selectedJourney, selectedActivity, $(this));
        });
        if (!dataFiltrable.is(":visible")){
            $('[data-target="no-results"]').show();
            $('[data-target="results"]').hide();
        }else {
            $('[data-target="no-results"]').hide();
            $('[data-target="results"]').show();
        }

    };
    this.filterChollos = function (selectedMealPlan, selectedNights, selectedHotel, selectedAirport, selectedJourney, selectedActivity, element) {
        let nights = element.data('nights');
        let mealPlan = element.data('mealplan');
        let hotelId = element.data('hotelid');
        let airport =  element.data('airport');
        let journey =  element.data('journey');
        let activities =  element.data('activity');
        isNaN(activities) ? activities.split(';') : activities = [activities.toString()];

        if (isNaN(mealPlan)){
            mealPlan = mealPlan.split(';').pop()
        }

        if (selectedNights || selectedMealPlan || selectedHotel || selectedAirport || selectedJourney || selectedActivity) {
            $('[data-target="#moreNightsCollapsed"]').hide();
            $('[data-element="moreNightsModule"]').hide();
        } else {
            $('[data-target="#moreNightsCollapsed"]').show();
            $('[data-element="moreNightsModule"]').show();
            this.collapseOptions();
        }

        if (
            (!selectedNights || selectedNights == nights) && (selectedMealPlan == mealPlan || !selectedMealPlan)
            && (hotelId == selectedHotel || !selectedHotel) && (airport == selectedAirport || !selectedAirport)
            && (journey == selectedJourney || !selectedJourney)
            && (activities.includes(selectedActivity) || !selectedActivity)
        ) {
            element.show();
        }else {
            element.hide()
        }
    };

    this.uncollapseOptions = function () {
        var moreNightsButton = $('[data-target="#moreNightsCollapsed"]');

        if (moreNightsButton.hasClass('collapsed')) {
            moreNightsButton.trigger('click');
        }
    };

    this.collapseOptions = function () {
        var moreNightsButton = $('[data-target="#moreNightsCollapsed"]');

        if (!moreNightsButton.hasClass('collapsed')) {
            moreNightsButton.trigger('click');
        }
    };

    this.initialize();
};

export default ChollosFilterer;
